<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import welcome from '@/modules/welcome'
export default {
  name: 'App',
  beforeCreate () {
    if (window.location.hash.indexOf('login') !== -1) {
      // const hash = window.location.hash.replace('#', '')
      const hostname = window.location.hostname
      if (hostname.indexOf('teacher') !== -1) {
        this.$router.push({name: 'LOGIN_T'})
      } else if (hostname.indexOf('student') !== -1 || hostname.indexOf('www') !== -1) {
        this.$router.push({name: 'LOGIN_S'})
      } else if (hostname.indexOf('admin') !== -1) {
        this.$router.push({name: 'LOGIN_A'})
      } else if (hostname === 'kwonlab.co.kr') {
        window.location.href = `${window.location.protocol}//www.${hostname}:${window.location.port}`
      }
    }
  },
  created () {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress) {
        let meta = to.meta.progress
        this.$Progress.parseMeta(meta)
      }
      this.$Progress.start()
      next()
    })
    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
    })
  },
  mounted () {
    this.$Progress.finish()
    welcome.writeConsoleWelcome()
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue